import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { profile } from '../data/resume.js';
import { CloseIcon, MenuIcon } from './Icons.js';

export const SECTIONS = [
    { id: 'about', label: 'About' },
    { id: 'education', label: 'Education' },
    { id: 'experience', label: 'Experience' },
    { id: 'projects', label: 'Projects' },
];

// Highlights the section currently in view while on the home page.
const useActiveSection = (enabled) => {
    const [active, setActive] = useState('about');

    useEffect(() => {
        if (!enabled || typeof IntersectionObserver === 'undefined') return undefined;
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) setActive(entry.target.id);
                });
            },
            { rootMargin: '-45% 0px -50% 0px' }
        );
        SECTIONS.forEach(({ id }) => {
            const el = document.getElementById(id);
            if (el) observer.observe(el);
        });
        return () => observer.disconnect();
    }, [enabled]);

    return enabled ? active : null;
};

const Nav = () => {
    const { pathname } = useLocation();
    const [open, setOpen] = useState(false);
    const active = useActiveSection(pathname === '/');

    useEffect(() => setOpen(false), [pathname]);

    return (
        <header className="site-header">
            <nav className="nav container" aria-label="Main">
                <Link to="/" className="brand" aria-label="Steven Camacho, home">
                    <span className="brand-mark">SC</span>
                    <span className="brand-name">Steven Camacho</span>
                </Link>

                <ul className={`nav-links ${open ? 'is-open' : ''}`}>
                    {SECTIONS.map(({ id, label }) => (
                        <li key={id}>
                            <Link
                                to={{ pathname: '/', hash: `#${id}` }}
                                className={active === id ? 'is-active' : undefined}
                                aria-current={active === id ? 'true' : undefined}
                                onClick={() => setOpen(false)}
                            >
                                {label}
                            </Link>
                        </li>
                    ))}
                    <li>
                        <a href={profile.resumePdf} target="_blank" rel="noopener noreferrer">
                            Resume
                        </a>
                    </li>
                </ul>

                <div className="nav-actions">
                    <button
                        type="button"
                        className="icon-button nav-toggle"
                        onClick={() => setOpen((o) => !o)}
                        aria-label={open ? 'Close menu' : 'Open menu'}
                        aria-expanded={open}
                    >
                        {open ? <CloseIcon /> : <MenuIcon />}
                    </button>
                </div>
            </nav>
        </header>
    );
};

export default Nav;
